export default {
    options: {},
    steps: [],
    instance: undefined
}
